import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { RouterProvider } from "react-router/dom";

import { Providers } from "./providers";
import { router } from "./router";

import "./globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("Нет #root в index.html");

createRoot(root).render(
    <StrictMode>
        <Providers>
            <RouterProvider router={router} />
        </Providers>
    </StrictMode>,
);
